import { connect } from 'react-redux';
import R from 'ramda';
import { PAGES } from '../../constants';
import { setNavigation } from '_actions';
import Licenses from './page';

import {
  fetch,
  fetchList,
  patch,
  fetchAutocompleteSuggestions,
  setAutocompleteSelections,
  clearAutocompleteSuggestions,
  reactivateLicense,
  removeLicense,
  removeLicenseMachine,
  addSublicense,
  removeSublicense,
  deactivateLicenseUpgrade,
} from '_actions/licenses';

const mapStateToProps = state => ({
  licensesPage: R.pathOr({}, ['pages', PAGES.LICENSES], state)
});

const mapDispatchToProps = dispatch => ({
  onRefreshLicense: R.compose(dispatch, fetch), // ({licenseId})
  onModifyLicense: R.compose(dispatch, patch), // ({licenseId, payload})
  onReactivateLicense: R.compose(dispatch, reactivateLicense), // ({licenseId})
  onRemoveLicense: R.compose(dispatch, removeLicense), // ({licenseId})
  onAddSublicense: R.compose(dispatch, addSublicense), // ({licenseId, payload})
  onRemoveSublicense: R.compose(dispatch, removeSublicense), // ({licenseId, sublicenseId})
  onRemoveLicenseMachine: R.compose(dispatch, removeLicenseMachine), // ({licenseId})
  onDeactivateLicenseUpgrade: R.compose(dispatch, deactivateLicenseUpgrade), // ({licenseId, licenseUpgradeId})
  setNavigation: R.compose(dispatch, setNavigation), // {pageName, pageNum, ids, etc}
  onRefreshList: R.compose(dispatch, fetchList), // navigation, aka R.pathOr({}, ['pages', PAGES.INSTITUTIONS, 'navigation'], this.props.state)
  onTermChange: R.compose(dispatch, fetchAutocompleteSuggestions), // term
  onSelectionChange: R.compose(dispatch, setAutocompleteSelections), // selections
  onClearSuggestions: R.compose(dispatch, clearAutocompleteSuggestions),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Licenses);



// WEBPACK FOOTER //
// ./webAdmin/components/licenses/index.js